import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('localization/machine');
  }
}

export default new API();
